export function addCurrent(npssearch) {
    return {
        type: 'ADD_CURRENT',
        npssearch,
    }
}